// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeSlideDown {
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeSlideUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes pulse-ring {
  0%   { box-shadow: 0 0 0 0 rgba(51, 116, 238, 0.35); }
  70%  { box-shadow: 0 0 0 12px rgba(51, 116, 238, 0); }
  100% { box-shadow: 0 0 0 0 rgba(51, 116, 238, 0); }
}
@keyframes tick {
  0%,100% { opacity: 1; }
  50%      { opacity: 0.4; }
}
@keyframes popupZoomIn {
  0%   { transform: scale(0.6); opacity: 0; }
  60%  { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(1); }
}

.bcd-page {
  min-height: 100vh;
  background: #ffffff;
  font-family: "Inter", "Segoe UI", sans-serif;
  display: flex;
  flex-direction: column;
}

.bcd-header {
  width: 100%;
  background: #ffffff;
  padding: 0 40px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 1px 0 #e2e8f0, 0 4px 16px rgba(0,0,0,0.06);
  animation: fadeSlideDown 0.4s ease both;
}

.bcd-header-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.bcd-header-meta span {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}
.bcd-header-meta strong {
  color: #0f172a;
  font-weight: 600;
}

.bcd-header-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  text-transform: uppercase;
  flex: 1 1;
  text-align: center;
}

.bcd-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 4px;
  border: 1.5px solid #e2e8f0;
  background: #F69320;
  color: #fdfefe;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.15s;
}
.bcd-back-btn:hover {
  background: #f99008;
  border-color: #cbd5e1;
  color: #ffffff;
}

.bcd-content {
  flex: 1 1;
  width: 100%;
  padding: 36px 40px 60px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  animation: fadeSlideUp 0.45s ease both;
}

.bcd-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
}

.bcd-info-card {
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  border: 1px solid #fbad54;
}

.bcd-info-card-body {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  width: 100%;
}

.bcd-info-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: #000;
}

.bcd-info-value {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  width: 100%;
  text-align: center;

  display: block;   
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bcd-info-subvalue {
  display: block; 
  font-size: 14px;
  color: #626264;
  font-weight: 500;
  margin-top: 2px;
  text-align: center;
}

.bcd-time-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  width: 100%;
}

.bcd-time-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  border: 1px solid #f7b751;
}

.bcd-time-icon {
  font-size: 22px;
  margin-bottom: 2px;
}
.bcd-time-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: #000;
}
.bcd-time-value {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  text-align: center;
}

.bcd-time-card.duration .bcd-time-value {
  font-size: 22px;
  color: #1d4ed8;
 
}

.bcd-reason-row {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
}
.bcd-reason-card {
  background: #fff;
  border: 1px solid #f2b35b;
  border-radius: 16px;
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  min-width: 200px;
}
.bcd-reason-label {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  color: #000;
}
.bcd-reason-value {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
}

.bcd-action-area {
  background: #ffffff;
  border-radius: 18px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  border: 1px solid #fbc964;
}
.bcd-action-title {
  font-size: 16px;
  font-weight: 600;
  color: #2f3031;
  text-transform: uppercase;
}

.bcd-verdict-row {
  display: flex;
  gap: 20px;
}

.bcd-verdict-btn {
  padding: 12px 48px;
  border-radius: 10px;
  border: 2px solid transparent;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 140px; 
}
.bcd-verdict-btn:active {
  transform: translateY(0);
}

.bcd-ok-btn {
  background: #d1fae5;
  color: #065f46;
  border-color: #6ee7b7;
}
.bcd-ok-btn.active, .bcd-ok-btn:hover {
  border-radius: 10px;
  background: #10b981;
  color: white;
  border-color: #059669;
  box-shadow: 0 8px 24px rgba(16,185,129,0.35);
}
.bcd-ok-btn.active {
  animation: pulse-ring 1.4s ease-out infinite;
}

.bcd-nok-btn {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}
.bcd-nok-btn.active, .bcd-nok-btn:hover {
  border-radius: 10px;
  background: #ef4444;
  color: white;
  border-color: #dc2626;
  box-shadow: 0 8px 24px rgba(239,68,68,0.35);
}
.bcd-nok-btn.active {
  animation: pulse-ring 1.4s ease-out infinite;
}

.bcd-complete-btn {
  padding: 12px 48px;
  border-radius: 10px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: not-allowed;
  color: white;
  background: #9ca3af;
  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;
}
.bcd-complete-btn.enabled {
  background: #1d4ed8;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(29, 78, 216, 0.28);
}
.bcd-complete-btn.enabled:hover {
  background: #1e40af;
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.38);
}
.bcd-complete-btn.enabled:active {
  transform: translateY(0);
}

.bcd-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
}
.bcd-popup-box {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 18px;
  padding: 36px 32px;
  box-shadow: 0 20px 60px rgba(15,23,42,0.3);
  display: flex;
  flex-direction: column;
  gap: 24px;
  animation: popupZoomIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
.bcd-popup-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bcd-popup-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}
.bcd-popup-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.bcd-popup-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

.bcd-popup-textarea {
  width: 100%;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  padding: 12px 14px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  background: #f8fafc;
  color: #0f172a;
  transition: border-color 0.2s;
  box-sizing: border-box;
}
.bcd-popup-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  background: #fff;
}

.bcd-popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.bcd-popup-cancel {
  padding: 10px 24px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.bcd-popup-cancel:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.bcd-popup-confirm {
  padding: 10px 32px;
  border-radius: 8px;
  border: none;
  background: #ef4444;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
}
.bcd-popup-confirm:hover:not(:disabled) {
  background: #dc2626;
  transform: translateY(-1px);
}
.bcd-popup-confirm:disabled {
  background: #fca5a5;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .bcd-info-grid,
  .bcd-time-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .bcd-content {
    padding: 24px 20px 48px;
  }
  .bcd-header {
    padding: 0 20px;
  }
}
@media (max-width: 600px) {
  .bcd-info-grid,
  .bcd-time-row {
    grid-template-columns: 1fr;
  }
  .bcd-verdict-row {
    flex-direction: column;
    max-width: 100%;
  }
  .bcd-header-title {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/BlueCardScreen/bluecarddetails.css"],"names":[],"mappings":"AAAA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,4CAA4C,EAAE;EACrD,OAAO,4CAA4C,EAAE;EACrD,OAAO,yCAAyC,EAAE;AACpD;AACA;EACE,UAAU,UAAU,EAAE;EACtB,WAAW,YAAY,EAAE;AAC3B;AACA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,wDAAwD;EACxD,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;;EAElB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;;AAEhB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;AAC/D;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@keyframes fadeSlideDown {\n  from { opacity: 0; transform: translateY(-12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes fadeSlideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes pulse-ring {\n  0%   { box-shadow: 0 0 0 0 rgba(51, 116, 238, 0.35); }\n  70%  { box-shadow: 0 0 0 12px rgba(51, 116, 238, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(51, 116, 238, 0); }\n}\n@keyframes tick {\n  0%,100% { opacity: 1; }\n  50%      { opacity: 0.4; }\n}\n@keyframes popupZoomIn {\n  0%   { transform: scale(0.6); opacity: 0; }\n  60%  { transform: scale(1.05); opacity: 1; }\n  100% { transform: scale(1); }\n}\n\n.bcd-page {\n  min-height: 100vh;\n  background: #ffffff;\n  font-family: \"Inter\", \"Segoe UI\", sans-serif;\n  display: flex;\n  flex-direction: column;\n}\n\n.bcd-header {\n  width: 100%;\n  background: #ffffff;\n  padding: 0 40px;\n  height: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  box-shadow: 0 1px 0 #e2e8f0, 0 4px 16px rgba(0,0,0,0.06);\n  animation: fadeSlideDown 0.4s ease both;\n}\n\n.bcd-header-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.bcd-header-meta span {\n  font-size: 14px;\n  font-weight: 500;\n  color: #000;\n}\n.bcd-header-meta strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.bcd-header-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  text-transform: uppercase;\n  flex: 1;\n  text-align: center;\n}\n\n.bcd-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  border-radius: 4px;\n  border: 1.5px solid #e2e8f0;\n  background: #F69320;\n  color: #fdfefe;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.15s;\n}\n.bcd-back-btn:hover {\n  background: #f99008;\n  border-color: #cbd5e1;\n  color: #ffffff;\n}\n\n.bcd-content {\n  flex: 1;\n  width: 100%;\n  padding: 36px 40px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  animation: fadeSlideUp 0.45s ease both;\n}\n\n.bcd-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  width: 100%;\n}\n\n.bcd-info-card {\n  background: #fff;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  box-shadow: 0 2px 16px rgba(0,0,0,0.07);\n  border: 1px solid #fbad54;\n}\n\n.bcd-info-card-body {\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n  width: 100%;\n}\n\n.bcd-info-label {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #000;\n}\n\n.bcd-info-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0f172a;\n  width: 100%;\n  text-align: center;\n\n  display: block;   \n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bcd-info-subvalue {\n  display: block; \n  font-size: 14px;\n  color: #626264;\n  font-weight: 500;\n  margin-top: 2px;\n  text-align: center;\n}\n\n.bcd-time-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n  width: 100%;\n}\n\n.bcd-time-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n  box-shadow: 0 2px 16px rgba(0,0,0,0.07);\n  border: 1px solid #f7b751;\n}\n\n.bcd-time-icon {\n  font-size: 22px;\n  margin-bottom: 2px;\n}\n.bcd-time-label {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #000;\n}\n.bcd-time-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0f172a;\n  text-align: center;\n}\n\n.bcd-time-card.duration .bcd-time-value {\n  font-size: 22px;\n  color: #1d4ed8;\n \n}\n\n.bcd-reason-row {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  width: 100%;\n}\n.bcd-reason-card {\n  background: #fff;\n  border: 1px solid #f2b35b;\n  border-radius: 16px;\n  padding: 24px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n  box-shadow: 0 2px 16px rgba(0,0,0,0.07);\n  min-width: 200px;\n}\n.bcd-reason-label {\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: #000;\n}\n.bcd-reason-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0f172a;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  width: 100%;\n}\n\n.bcd-action-area {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.07);\n  border: 1px solid #fbc964;\n}\n.bcd-action-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2f3031;\n  text-transform: uppercase;\n}\n\n.bcd-verdict-row {\n  display: flex;\n  gap: 20px;\n}\n\n.bcd-verdict-btn {\n  padding: 12px 48px;\n  border-radius: 10px;\n  border: 2px solid transparent;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 140px; \n}\n.bcd-verdict-btn:active {\n  transform: translateY(0);\n}\n\n.bcd-ok-btn {\n  background: #d1fae5;\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n.bcd-ok-btn.active, .bcd-ok-btn:hover {\n  border-radius: 10px;\n  background: #10b981;\n  color: white;\n  border-color: #059669;\n  box-shadow: 0 8px 24px rgba(16,185,129,0.35);\n}\n.bcd-ok-btn.active {\n  animation: pulse-ring 1.4s ease-out infinite;\n}\n\n.bcd-nok-btn {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n.bcd-nok-btn.active, .bcd-nok-btn:hover {\n  border-radius: 10px;\n  background: #ef4444;\n  color: white;\n  border-color: #dc2626;\n  box-shadow: 0 8px 24px rgba(239,68,68,0.35);\n}\n.bcd-nok-btn.active {\n  animation: pulse-ring 1.4s ease-out infinite;\n}\n\n.bcd-complete-btn {\n  padding: 12px 48px;\n  border-radius: 10px;\n  border: none;\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: not-allowed;\n  color: white;\n  background: #9ca3af;\n  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;\n}\n.bcd-complete-btn.enabled {\n  background: #1d4ed8;\n  cursor: pointer;\n  box-shadow: 0 6px 18px rgba(29, 78, 216, 0.28);\n}\n.bcd-complete-btn.enabled:hover {\n  background: #1e40af;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.38);\n}\n.bcd-complete-btn.enabled:active {\n  transform: translateY(0);\n}\n\n.bcd-popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 16px;\n}\n.bcd-popup-box {\n  width: 100%;\n  max-width: 480px;\n  background: #fff;\n  border-radius: 18px;\n  padding: 36px 32px;\n  box-shadow: 0 20px 60px rgba(15,23,42,0.3);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  animation: popupZoomIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n.bcd-popup-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.bcd-popup-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #fee2e2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  flex-shrink: 0;\n}\n.bcd-popup-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.bcd-popup-subtitle {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.bcd-popup-textarea {\n  width: 100%;\n  border-radius: 10px;\n  border: 1.5px solid #e2e8f0;\n  padding: 12px 14px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: none;\n  background: #f8fafc;\n  color: #0f172a;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n.bcd-popup-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  background: #fff;\n}\n\n.bcd-popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.bcd-popup-cancel {\n  padding: 10px 24px;\n  border-radius: 8px;\n  border: 1.5px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.bcd-popup-cancel:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n.bcd-popup-confirm {\n  padding: 10px 32px;\n  border-radius: 8px;\n  border: none;\n  background: #ef4444;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.15s;\n}\n.bcd-popup-confirm:hover:not(:disabled) {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n.bcd-popup-confirm:disabled {\n  background: #fca5a5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .bcd-info-grid,\n  .bcd-time-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .bcd-content {\n    padding: 24px 20px 48px;\n  }\n  .bcd-header {\n    padding: 0 20px;\n  }\n}\n@media (max-width: 600px) {\n  .bcd-info-grid,\n  .bcd-time-row {\n    grid-template-columns: 1fr;\n  }\n  .bcd-verdict-row {\n    flex-direction: column;\n    max-width: 100%;\n  }\n  .bcd-header-title {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
